import { joinPaths, toQueryString } from 'utils/utils';

export async function metaApi(method, query = {}, body) {
	if (typeof window === 'undefined') {
		throw new Error('Trying to request server-side');
	}

	const baseUrl = 'https://meta-conversion-api.s-prod.pow.io';

	const res = await fetch(baseUrl, {
		mode: 'cors',
		headers: {
			'Content-Type': 'application/json'
		},
		method,
		body: body && JSON.stringify(body)
	});

	if (!res.ok) {
		throw res.status || res.error || res;
	}

	return res.json();
}
